export const SCREEN_ID_REGEX = new RegExp('^[A-Za-z0-9_]+$');
export const EMAIL_REGEX = /^[\w!#$%&'*+=?`{|}~^-]+(?:\.[\w!#$%&'*+=?`{|}~^-]+)*@(?:[a-zA-z0-9-]+\.)+[A-za-z]+$/;
export const CABINET_PATH_REGEX = /^https?:\/\/(?:.*)?[^.]+$/;
export const EMAIL_MATCH_REGEXP = /^[\w!#$%&'*+=?`{|}~^-]+(?:\.[\w!#$%&'*+=?`{|}~^-]+)*@(?:[a-zA-z0-9-]+\.)+[A-za-z]+$/;
export const PASSWORD_MATCH_REGEXP = /^[a-zA-Z\d$#@!%^&*?]{6,20}$/;
export const US_ZIPCODE_MATCH_REGEXP = /^\d{5}(-\d{4})?$/;
